import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

import * as mutationTypes from '../mutation-types';

const state = () => ({
    selectedShoes: null,
    shoes: [],
    defaultShoes: null,
    loaders: {
        gltf: new GLTFLoader(),
      },
});

const getters = {
    selectedShoes: state => state.selectedShoes,
    shoes: state => state.shoes,
    defaultShoes: state => state.defaultShoes,
    shoesById: state => (id) => {
        return state.shoes.filter(s => s.id === id)[0];
    }
};

const mutations = {
    [mutationTypes.INIT_SHOES] (state,shoes) {

        if(!shoes || shoes.length == 0) {
            state.shoes = [];
            state.defaultShoes = null;

        } else {

            state.shoes = shoes;

            const defaultShoes = shoes.filter(el => el.default )[0];
            if(defaultShoes) {
                state.defaultShoes = defaultShoes;
            } else {
                state.defaultShoes = shoes[0];
            }

        }

        // console.log(state.shoes,state.defaultShoes);

        
    },
    [mutationTypes.SET_SELECTED_SHOES] (state,selectedShoes) {
        state.selectedShoes = selectedShoes;
        // console.log(state.selectedShoes);
    },
    [mutationTypes.RESET_SELECTED_SHOES] (state) {
        state.selectedShoes = null;
    }
};

const actions = {
    initShoes: ({ commit }, payload) => {
        // console.log(payload);
        commit(mutationTypes.INIT_SHOES,payload);
    },
    setSelectedShoes: ({commit,dispatch,state},payload) => {
        // todo complete

        return new Promise((resolve,reject) => {
            try {

                if( (state.selectedShoes === payload) || !payload) {
                    resolve();
                    return;
                }
                    

                if(state.selectedShoes) {
                    dispatch('removeShoes');
                }

                commit(mutationTypes.SET_SELECTED_SHOES,payload);
                dispatch('uploadShoes',payload).then(() => {
                    // dispatch('render',null,{root:true});
                    resolve();
                });
                
                
            } catch (error) {
                reject(error);
            }
        });
        
        
    },
    removeShoes: ({state, commit, rootGetters, dispatch}) => {
        // todo complete
        if(!state.selectedShoes) {
            return;
        }

        rootGetters['mannequin/poser'].inst.remove(state.selectedShoes.inst);
        dispatch('disposeShoes',state.selectedShoes.inst);

        commit(mutationTypes.RESET_SELECTED_SHOES);

    },
    uploadShoes: ({state,rootGetters,dispatch },payload) => {

        return new Promise((resolve,reject) => {

            try {

                if(!payload)
                    resolve();

                state.loaders.gltf.load(payload.src,(gltf) => {
                    // todo complete
                    state.selectedShoes.inst = gltf.scene;
                    dispatch('mannequin/setMapEncoding',gltf.scene,{root: true});
                    // console.log(gltf.scene);
                    rootGetters['mannequin/poser'].inst.add(gltf.scene);

                    resolve();
                });
                
            } catch (error) {
                reject(error);
            }

        })

        
    },
    disposeShoes: ({dispatch},payload) => {
        // todo complete
        dispatch('objects3d/dispose',payload,{root:true});
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  }